import { headerConnect as connect } from 'components/Shared/connect';
import { useEffect } from 'react';
import Modal from 'components/Shared/Modal';
import { SiteModeSelector } from 'components/SiteMode/siteModeSelector';
import { SiteMode } from 'models/SiteMode';
import { rm, isBrowser } from 'utils';
import { getQaDataAttr } from '@bygghemmait/utilities';
import styles from './styles.scss';
import { setSiteMode } from 'store/appShell/actions';
import { useToggle } from 'hooks';

interface MergedProps {
  canSelectSiteMode: boolean;
  setDefaultSiteMode: () => Promise<void>;
}

const _SiteModeModal = ({ setDefaultSiteMode, canSelectSiteMode }: MergedProps) => {
  const [show, setShow] = useToggle(false);
  const close = () => setShow(false);

  const handleClose = () => {
    void setDefaultSiteMode().then(() => close());
  };

  const closeSiteModeModal = () => {
    if (isBrowser() && window.isReact) {
      close();
    }
  };

  useEffect(() => {
    if (canSelectSiteMode) {
      setShow(true);
    }
  }, [canSelectSiteMode, setShow]);

  return (
    <Modal onClose={handleClose} show={show}>
      <h3 className={styles.welcome}>{rm('b2b_welcome')}</h3>
      <p>{rm('b2b_choose_mode')}</p>
      <div className={styles.siteModeSelectorWrapper} {...getQaDataAttr('siteModeModal')}>
        <SiteModeSelector closeSiteModeModal={closeSiteModeModal} />
      </div>
    </Modal>
  );
};

export const SiteModeModal = connect<MergedProps>(
  state => ({
    canSelectSiteMode: state.appShell.siteMode === SiteMode.Unknown
  }),
  dispatch => ({
    setDefaultSiteMode: () => dispatch(setSiteMode(SiteMode.Private))
  })
)(_SiteModeModal);
